import classNames from 'classnames';
import { Portal, svgSprite } from '../../../../hybrid/wrappers';
import css from './VerifyModal.module.scss';
import T from '../../../../common/components/T';
import Link from 'next/link';

export default function VerifyModal({ closeHandler }) {
    const verifyTabLink = (
        <Link href='/profile#verification'>
            <T textName='profile-1' defaultStr='профиль' />
        </Link>
    );
    return (
        <Portal closeHandler={closeHandler}>
            <div className={css.modal}>
                <div onClick={closeHandler} className={classNames('circleButton', css.modalClose)}>
                    {svgSprite('cross')}
                </div>
                <p className={css.text}>
                    <T
                        vars={{ profile: verifyTabLink }}
                        textName='verify-modal-wallet-text'
                        defaultStr='Пожалуйста, пройдите верификацию на странице ${profile}.'
                    />
                </p>
            </div>
        </Portal>
    );
}
